

export interface AlsBase {
    id:number|null
    libelle:string
    commit:boolean
}

export const getDefaultAlsBase = (commit:boolean=true):AlsBase => {
    return {
        id:null,
        libelle:'',
        commit
    }
}